/**
 * Layout structure for static pages content
 *
 * Provides consistent styling and container structure for static pages.
 * Note: Does not include <main> tag as ScreenWrapper already provides it.
 */

import styles from './StaticLayout.module.css'

export default function StaticLayout ({ children }) {
  return (
    <>
      <div className={styles.staticLayout}>
        {children}
      </div>
    </>
  )
}
